import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNpmComponent } from './simple-icons-npm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNpmComponent ],
    exports:      [ SimpleIconsNpmComponent ],
    bootstrap:    []
})
export class SimpleIconsNpmModule {}
